import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'

import ApartmentSelector from './ApartmentSelector'
import { useSelectedApartment } from './apartmentStore'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  titleBlock: { display: 'flex', flexDirection: 'column' },
  building: { color: theme.palette.text.secondary },
  actions: { display: 'flex', alignItems: 'center', gap: theme.spacing(2) }
}))

// Shared header for every apartment page: section title + selected building +
// the apartment switcher, plus an optional action slot (e.g. a "+ New" button).
// Global/admin pages (clusters, operators) set showSelector={false}.
const ApartmentPageHeader = ({
  title,
  action,
  showSelector = true,
  subtitle
}) => {
  const classes = useStyles()
  const [apartment] = useSelectedApartment()

  return (
    <div className={classes.header}>
      <div className={classes.titleBlock}>
        <Typography variant="h5">{title}</Typography>
        {(subtitle || showSelector) && (
          <Typography variant="body2" className={classes.building}>
            {subtitle || apartment.name}
          </Typography>
        )}
      </div>
      <div className={classes.actions}>
        {action}
        {showSelector && <ApartmentSelector />}
      </div>
    </div>
  )
}

ApartmentPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  showSelector: PropTypes.bool,
  subtitle: PropTypes.string
}

export default ApartmentPageHeader
